import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const productStateBaseUrl = `${apiUrl}/productState`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const productStatesApi = {
  getAll: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${productStateBaseUrl}?${query}`);
  },
  save: productState => {
    return Axios.post(productStateBaseUrl, productState, config);
  },
  delete: id => {
    return Axios.delete(`${productStateBaseUrl}/${id}`, config);
  },
  upload: (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return Axios.post(`${productStateBaseUrl}/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};
